module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hwDO7"))).then(() => parcelRequire('ikE14'));